module.exports = __webpack_public_path__ + "img/brickstreamcarddevice.2991f866.png";